/**
 * 사용자 프로필 관련 유틸리티 함수들
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { resolveStorageKeys } from '../storage-keys';
/**
 * 사용자 프로필 가져오기 함수 생성
 */ export var createFetchUserProfile = function(config) {
    return /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(token) {
            var storageKeys, storedUser, user, _sessionInfo_account, sessionInfo, profileResponse, user1, usernameError, sessionInfo1, defaultUser, sessionError, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            10,
                            ,
                            11
                        ]);
                        storageKeys = resolveStorageKeys(config.storageKeys);
                        // 중복 요청 방지
                        if (config.lastTokenRef.current === token) {
                            console.log('[AuthUtils] 같은 토큰으로 이미 처리됨, 스킵:', token.substring(0, 10) + '...');
                            return [
                                2
                            ];
                        }
                        config.lastTokenRef.current = token;
                        console.log('[AuthUtils] 사용자 프로필 가져오기 시도');
                        // 토큰 설정
                        config.tokenManager.setToken(token);
                        config.apiService.setToken(token);
                        // 웹 환경에서는 이미 저장된 사용자 정보를 사용
                        if (!config.isVSCodeEnv) {
                            storedUser = localStorage.getItem(storageKeys.userKey);
                            if (storedUser) {
                                try {
                                    user = JSON.parse(storedUser);
                                    config.setAuthState({
                                        user: user,
                                        token: token,
                                        isAuthenticated: true,
                                        isLoading: false,
                                        isInitialized: true,
                                        error: null
                                    });
                                    console.log('[AuthUtils] 사용자 프로필 설정 완료:', user.username);
                                    return [
                                        2
                                    ];
                                } catch (parseError) {
                                    console.warn('[AuthUtils] 저장된 사용자 정보 파싱 실패:', parseError);
                                }
                            }
                            return [
                                2
                            ]; // 웹 환경에서는 API 호출하지 않음
                        }
                        if (!(config.isVSCodeEnv && config.ideMessengerInstance)) return [
                            3,
                            9
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            config.ideMessengerInstance.request('getControlPlaneSessionInfo', {})
                        ];
                    case 2:
                        sessionInfo = _state.sent();
                        if (!(sessionInfo === null || sessionInfo === void 0 ? void 0 : (_sessionInfo_account = sessionInfo.account) === null || _sessionInfo_account === void 0 ? void 0 : _sessionInfo_account.label)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            config.apiService.getAxiosInstance().get("/api/v1/users/username/".concat(sessionInfo.account.label))
                        ];
                    case 3:
                        profileResponse = _state.sent();
                        if (profileResponse === null || profileResponse === void 0 ? void 0 : profileResponse.data) {
                            user1 = {
                                id: profileResponse.data.id || profileResponse.data.uuid || sessionInfo.account.id,
                                username: profileResponse.data.username || sessionInfo.account.label,
                                name: profileResponse.data.name || sessionInfo.account.label,
                                email: profileResponse.data.email,
                                profileImage: profileResponse.data.profileImage,
                                avatar: profileResponse.data.avatar || profileResponse.data.profileImage
                            };
                            config.setAuthState({
                                user: user1,
                                token: token,
                                isAuthenticated: true,
                                isLoading: false,
                                isInitialized: true,
                                error: null
                            });
                            console.log('[AuthUtils] Username 기반 사용자 프로필 설정 완료:', user1.username);
                            return [
                                2
                            ];
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        usernameError = _state.sent();
                        console.error('[AuthUtils] Username 기반 프로필 가져오기 실패:', usernameError);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        _state.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4,
                            config.ideMessengerInstance.request('getControlPlaneSessionInfo', {})
                        ];
                    case 7:
                        sessionInfo1 = _state.sent();
                        if (sessionInfo1 === null || sessionInfo1 === void 0 ? void 0 : sessionInfo1.account) {
                            defaultUser = {
                                id: sessionInfo1.account.id,
                                username: sessionInfo1.account.label || 'user',
                                name: sessionInfo1.account.label || 'VSCode User',
                                email: undefined,
                                profileImage: undefined,
                                avatar: undefined
                            };
                            config.setAuthState({
                                user: defaultUser,
                                token: token,
                                isAuthenticated: true,
                                isLoading: false,
                                isInitialized: true,
                                error: null
                            });
                            console.log('[AuthUtils] VSCode 기본 사용자 정보 생성 완료:', defaultUser.username);
                            return [
                                2
                            ];
                        }
                        return [
                            3,
                            9
                        ];
                    case 8:
                        sessionError = _state.sent();
                        console.error('[AuthUtils] VSCode 세션 정보 가져오기 실패:', sessionError);
                        return [
                            3,
                            9
                        ];
                    case 9:
                        // 최종적으로 실패한 경우에만 오류 상태 설정
                        config.setAuthState(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                isLoading: false,
                                isInitialized: true,
                                error: '사용자 정보를 가져올 수 없습니다'
                            });
                        });
                        return [
                            3,
                            11
                        ];
                    case 10:
                        error = _state.sent();
                        console.error('[AuthUtils] fetchUserProfile 중 오류:', error);
                        config.setAuthState(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                isLoading: false,
                                isInitialized: true,
                                error: '인증 중 오류가 발생했습니다'
                            });
                        });
                        return [
                            3,
                            11
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        });
        return function(token) {
            return _ref.apply(this, arguments);
        };
    }();
};
/**
 * 사용자 이메일 가져오기 함수 생성  
 */ export var createFetchUserEmail = function(config) {
    return /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(authState, updateUser) {
            var storageKeys, USERINFO_ENDPOINT, tokenType, response, _ref, email, name, picture, preferred_username, idToken, _idToken_split, _, payloadB64, json, _authState_user, _authState_user1, _authState_user2, _authState_user3, _response_data, _config_apiService, username, _body_profile, axios, url, profResp, body, candidate, e, _response_data1, _response_data2, _response_data3, _response_data4, alternativeEmail, _authState_user4, _authState_user5, _authState_user6, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log('[AuthUtils] 사용자 이메일 가져오기 시도');
                        storageKeys = resolveStorageKeys(config.storageKeys);
                        if (!authState.token || !authState.user) {
                            console.warn('[AuthUtils] 토큰 또는 사용자 정보가 없어 이메일을 가져올 수 없습니다.');
                            return [
                                2,
                                undefined
                            ];
                        }
                        // 이미 이메일이 있다면 반환
                        if (authState.user.email) {
                            console.log('[AuthUtils] 이미 사용자 이메일 정보가 존재:', authState.user.email);
                            return [
                                2,
                                authState.user.email
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            ,
                            11
                        ]);
                        USERINFO_ENDPOINT = "".concat(import.meta.env.VITE_AUTH_SERVER_URL || 'https://auth.ugot.uk', "/oauth2/userinfo");
                        tokenType = 'Bearer';
                        return [
                            4,
                            config.apiService.getAxiosInstance().get(USERINFO_ENDPOINT, {
                                headers: {
                                    'Authorization': "".concat(tokenType, " ").concat(authState.token)
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        console.log('[AuthUtils] Userinfo 응답 전체 데이터:', JSON.stringify(response.data, null, 2));
                        // OIDC userinfo 표준 필드 매핑 (서버 구현 참조: OidcUserInfoConfig.createUserInfoClaims)
                        // sub, preferred_username, email, email_verified, name, picture
                        _ref = (response === null || response === void 0 ? void 0 : response.data) || {}, email = _ref.email, name = _ref.name, picture = _ref.picture, preferred_username = _ref.preferred_username;
                        // 보강: userinfo.picture가 없으면 저장된 ID 토큰에서 picture 추출 시도
                        if (!(typeof picture === 'string' && picture.trim() !== '')) {
                            try {
                                idToken = localStorage.getItem(storageKeys.idTokenKey);
                                if (idToken) {
                                    _idToken_split = _sliced_to_array(idToken.split('.'), 2), _ = _idToken_split[0], payloadB64 = _idToken_split[1];
                                    if (payloadB64) {
                                        json = JSON.parse(atob(payloadB64.replace(/-/g, '+').replace(/_/g, '/')));
                                        if (typeof (json === null || json === void 0 ? void 0 : json.picture) === 'string' && json.picture.trim() !== '') {
                                            picture = json.picture;
                                        }
                                        // 누락된 항목 보강
                                        if (!email && typeof (json === null || json === void 0 ? void 0 : json.email) === 'string') email = json.email;
                                        if (!name && typeof (json === null || json === void 0 ? void 0 : json.name) === 'string') name = json.name;
                                        if (!preferred_username && typeof (json === null || json === void 0 ? void 0 : json.preferred_username) === 'string') preferred_username = json.preferred_username;
                                    }
                                }
                            } catch (e) {
                                console.warn('[AuthUtils] ID 토큰 기반 picture 보강 실패:', e === null || e === void 0 ? void 0 : e.message);
                            }
                        }
                        if (!email) return [
                            3,
                            8
                        ];
                        console.log('[AuthUtils] 이메일 정보 획득:', email);
                        updateUser({
                            email: email,
                            // 표준 picture를 프론트의 profileImage로 동기화
                            profileImage: typeof picture === 'string' && picture.trim() !== '' ? picture : (_authState_user = authState.user) === null || _authState_user === void 0 ? void 0 : _authState_user.profileImage,
                            // name 업데이트(표시명)
                            name: typeof name === 'string' && name.trim() !== '' ? name : (_authState_user1 = authState.user) === null || _authState_user1 === void 0 ? void 0 : _authState_user1.name,
                            // username은 preferred_username가 있으면 보정 (기존 값 우선)
                            username: ((_authState_user2 = authState.user) === null || _authState_user2 === void 0 ? void 0 : _authState_user2.username) || preferred_username
                        });
                        if (!!(typeof picture === 'string' && picture.trim() !== '')) return [
                            3,
                            7
                        ];
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            6,
                            ,
                            7
                        ]);
                        username = ((_authState_user3 = authState.user) === null || _authState_user3 === void 0 ? void 0 : _authState_user3.username) || (response === null || response === void 0 ? void 0 : (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.preferred_username);
                        if (!(username && ((_config_apiService = config.apiService) === null || _config_apiService === void 0 ? void 0 : _config_apiService.getAxiosInstance))) return [
                            3,
                            5
                        ];
                        axios = config.apiService.getAxiosInstance();
                        url = "/api/v1/users/username/".concat(encodeURIComponent(username), "/profile");
                        console.log('[AuthUtils] 보강용 프로필 API 호출:', url);
                        return [
                            4,
                            axios.get(url)
                        ];
                    case 4:
                        profResp = _state.sent();
                        body = (profResp === null || profResp === void 0 ? void 0 : profResp.data) || {};
                        candidate = (body === null || body === void 0 ? void 0 : (_body_profile = body.profile) === null || _body_profile === void 0 ? void 0 : _body_profile.avatarUrl) || (body === null || body === void 0 ? void 0 : body.avatarUrl) || (body === null || body === void 0 ? void 0 : body.profileImageUrl) || (body === null || body === void 0 ? void 0 : body.profileImage);
                        if (typeof candidate === 'string' && candidate.trim() !== '') {
                            updateUser({
                                profileImage: candidate
                            });
                        }
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        console.warn('[AuthUtils] 보강용 프로필 API 호출 실패:', e === null || e === void 0 ? void 0 : e.message);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2,
                            email
                        ];
                    case 8:
                        console.warn('[AuthUtils] Userinfo 응답에서 이메일을 찾을 수 없습니다. 응답 데이터:', response === null || response === void 0 ? void 0 : response.data);
                        // 다른 필드에서 이메일 찾기 시도
                        alternativeEmail = (response === null || response === void 0 ? void 0 : (_response_data1 = response.data) === null || _response_data1 === void 0 ? void 0 : _response_data1['email_verified']) || (response === null || response === void 0 ? void 0 : (_response_data2 = response.data) === null || _response_data2 === void 0 ? void 0 : _response_data2['user_email']) || (response === null || response === void 0 ? void 0 : (_response_data3 = response.data) === null || _response_data3 === void 0 ? void 0 : _response_data3['mail']) || (response === null || response === void 0 ? void 0 : (_response_data4 = response.data) === null || _response_data4 === void 0 ? void 0 : _response_data4['emailAddress']);
                        if (alternativeEmail) {
                            console.log('[AuthUtils] 대체 필드에서 이메일 발견:', alternativeEmail);
                            updateUser({
                                email: alternativeEmail
                            });
                            return [
                                2,
                                alternativeEmail
                            ];
                        }
                        // 이메일이 없더라도 picture/name이 온 경우 사용자 정보 동기화
                        if (picture || name || preferred_username) {
                            ;
                            updateUser({
                                profileImage: typeof picture === 'string' && picture.trim() !== '' ? picture : (_authState_user4 = authState.user) === null || _authState_user4 === void 0 ? void 0 : _authState_user4.profileImage,
                                name: typeof name === 'string' && name.trim() !== '' ? name : (_authState_user5 = authState.user) === null || _authState_user5 === void 0 ? void 0 : _authState_user5.name,
                                username: ((_authState_user6 = authState.user) === null || _authState_user6 === void 0 ? void 0 : _authState_user6.username) || preferred_username
                            });
                        }
                        return [
                            2,
                            undefined
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        error = _state.sent();
                        console.error('[AuthUtils] 이메일 가져오기 실패:', error);
                        return [
                            2,
                            undefined
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        });
        return function(authState, updateUser) {
            return _ref.apply(this, arguments);
        };
    }();
};
